module.exports = __webpack_public_path__ + "img/boat_stopped.89fe9059.svg";